import { computeCameraSnapshotForBounds as computeFit } from '../../shared/camera-fit.mjs'

export type Bounds = { x: number; y: number; z: number }

export type CameraSnapshot = {
  position: { x: number; y: number; z: number }
  quaternion: { x: number; y: number; z: number; w: number }
  fov: number
  near: number
  far: number
  target: { x: number; y: number; z: number }
  up: { x: number; y: number; z: number }
  mode: 'orbit' | 'tilt'
}

export type FitOpts = Partial<{
  margin: number
  phi: number
  theta: number
  zoom: number
  targetYOffset: number
  fov: number
  canvasWidth: number
  canvasHeight: number
  target: { x: number; y: number; z: number }
  cameraMode: 'orbit' | 'tilt'
  tiltPitch: number
  tiltRoll: number
  tiltTurntable: number
}>

export const DEFAULT_FIT_OPTS: Readonly<FitOpts> = {
  fov: 45,
  phi: 0.6,
  theta: 0,
  margin: 0.95,
  zoom: 0.85,
  cameraMode: 'orbit',
}

// Pure helper: compute a reasonable camera pose that frames bounds.
// Matches CameraController.fitToBounds math, without needing a live camera/canvas.
export function computeCameraSnapshotForBounds(bounds: Bounds, opts?: FitOpts): CameraSnapshot {
  // Delegate to the shared ESM implementation so math stays consistent across app and CLI.
  return computeFit(bounds as any, opts as any) as CameraSnapshot
}
